import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import {
  GridRow,
  GridColumn,
  // Loader,
  Button,
} from "arv-reactcomponents";

import { isDesktop, getCurrentHref } from "../../utils";
import ProductView from "./ProductView";
import ProductsScrolled from "./ProductsScrolled";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";

class ProductList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gridActive: true,
      blockActive: false,
    };

    this.siteHost = window.location.host;
    this.triggerChange = this.triggerChange.bind(this);
    this.blockButtonClick = this.blockButtonClick.bind(this);
  }

  componentDidUpdate() {
    this.triggerChange();
  }

  get isGridActiveClassName() {
    return (this.state.gridActive && "nw-productlist-grid-active") || "";
  }

  get isBlockActiveClassName() {
    return (this.state.blockActive && "nw-productlist-block-active") || "";
  }

  get noOfElementsInRow() {
    if (!isDesktop) {
      return (this.state.gridActive && 2) || 1;
    }

    return 3;
  }

  triggerChange() {
    this.ProductsScrolledRef.triggerChange(
      document.querySelectorAll(".nw-productlist-mainlist")[0],
    );
  }

  blockButtonClick(type, event) {
    event.preventDefault();
    let gridView = false;
    let blockView = false;
    switch (type) {
      case "gridActive":
        gridView = true;
        break;
      case "blockActive":
        blockView = true;
        break;
      default:
        break;
    }
    this.setState({
      gridActive: gridView,
      blockActive: blockView,
    });
    Analytics.trackEvent({
      action:
        type === "gridActive" ? Event.action.GRID_VIEW : Event.action.LIST_VIEW,
      label: getCurrentHref(),
      category: Event.category.LISTING_PAGE,
    });
  }

  render() {
    const { list, totalElements } = this.props;

    return (
      <Fragment>
        <GridRow className={`nw-productlist ${this.isBlockActiveClassName}`}>
          <GridColumn>
            <div className="nw-productlist-togglewrap nw-mobile-only">
              <Button
                onClick={e => this.blockButtonClick("gridActive", e)}
                className={`nw-productlist-grid ${this.isGridActiveClassName}`}
              >
                <i className="icomoon-th-large" />
              </Button>
              <Button
                onClick={e => this.blockButtonClick("blockActive", e)}
                className={`nw-productlist-block ${
                  this.isBlockActiveClassName
                }`}
              >
                <i className="icomoon-square" />
              </Button>
            </div>
          </GridColumn>
          <GridColumn className="nw-productlist-mainlist">
            <GridRow itemScope itemType="http://schema.org/ItemList">
              <GridColumn className="nwc-hide">
                <div itemProp="numberOfItems">{list.length}</div>
              </GridColumn>
              {list.map((item, index) => (
                <GridColumn
                  itemProp="itemListElement"
                  itemScope
                  itemType="http://schema.org/ListItem"
                  key={item.id}
                  className="nwc-grid-col-xs-6 nwc-grid-col-sm-4"
                >
                  <div itemProp="position" className="nwc-hide">
                    {index + 1}
                  </div>
                  <div itemProp="url" className="nwc-hide">
                    {`${this.siteHost}${item.url}`}
                  </div>
                  <div itemProp="image" className="nwc-hide">
                    {item.imagePath}
                  </div>
                  <div itemProp="name" className="nwc-hide">
                    {item.name}
                  </div>
                  <ProductView
                    currentIndex={index}
                    index={index}
                    link={item.url}
                    mainImage={item.imagePath}
                    altImage={item.altImagePath}
                    imageWidth={item.imageWidth}
                    imageHeight={item.imageHeight}
                    imageColor={item.imageColor}
                    brandText={item.brand}
                    productTitle={item.name}
                    isNew={item.isNew}
                    discountRange={item.discountRange}
                    mrpRange={item.mrpRange}
                    sellingPriceRange={item.sellingPriceRange}
                    promotions={item.promotions}
                    isAllPromotions={this.props.isAllPromotions}
                    styleId={item.id}
                    moreColors={item.moreColors}
                  />
                </GridColumn>
              ))}
            </GridRow>
          </GridColumn>
        </GridRow>
        <ProductsScrolled
          ref={context => {
            this.ProductsScrolledRef = context;
          }}
          noOfElements={list.length}
          totalElements={totalElements}
          elemsInRow={this.noOfElementsInRow}
        />
      </Fragment>
    );
  }
}

ProductList.defaultProps = {
  list: null,
  isAllPromotions: false,
};

ProductList.propTypes = {
  isAllPromotions: PropTypes.bool,
  list: PropTypes.arrayOf(PropTypes.object),
  totalElements: PropTypes.number.isRequired,
};

export default ProductList;



// WEBPACK FOOTER //
// ./src/component/ProductList/index.js